/**
 * Shadow tokens — verbatim from source --shadow-* .
 * On web, RN-Web passes `boxShadow` through, so we expose the var() refs
 * (resolved by the global stylesheet) for parity with the original.
 */
export const shadows = {
  sm: 'var(--shadow-sm)',
  base: 'var(--shadow)',
  md: 'var(--shadow-md)',
  lg: 'var(--shadow-lg)',
  focus: 'var(--shadow-focus)',
} as const;

export type Shadows = typeof shadows;
